/* eslint-disable */

import { createApi } from '@reduxjs/toolkit/query/react'
import getChargeAmpsApiPath from '../../../lib/getChargeAmpsApiPath'
import { baseQueryWithReauth } from './fetchBaseQueryWithReauth'

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseApi = createApi({
    reducerPath: 'wapi',
    baseQuery: (args, api, extraOptions) =>
        baseQueryWithReauth(args, api, { ...extraOptions, baseUrl: getChargeAmpsApiPath() }),
    endpoints: () => ({}),
})
